var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01434 8.08925C4.69413 7.51409 4.08 7.125 3.375 7.125C2.33947 7.125 1.5 7.96447 1.5 9C1.5 10.0355 2.33947 10.875 3.375 10.875C4.08 10.875 4.69413 10.4859 5.01434 9.91075M5.01434 8.08925C5.16447 8.35891 5.25 8.66947 5.25 9C5.25 9.33053 5.16447 9.64109 5.01434 9.91075M5.01434 8.08925L12.9857 3.66075M5.01434 9.91075L12.9857 14.3393M12.9857 14.3393C12.8355 14.6089 12.75 14.9195 12.75 15.25C12.75 16.2855 13.5895 17.125 14.625 17.125C15.6605 17.125 16.5 16.2855 16.5 15.25C16.5 14.2145 15.6605 13.375 14.625 13.375C13.92 13.375 13.3059 13.7641 12.9857 14.3393ZM12.9857 3.66075C13.3059 4.23591 13.92 4.625 14.625 4.625C15.6605 4.625 16.5 3.78553 16.5 2.75C16.5 1.71447 15.6605 0.875 14.625 0.875C13.5895 0.875 12.75 1.71447 12.75 2.75C12.75 3.08053 12.8355 3.39109 12.9857 3.66075Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.180e651900de7fb8c5f81956f7e3bc14.svg";
export { ForwardRef as ReactComponent };